import { HoverCardWithLink } from '@/components/hover-card-with-link';
import { RoundedButton } from '@/components/rounded-button';
import { getIconPathFromAppId } from '@/utils';
import { Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';

const dexs = [
  {
    name: 'Rooster',
    appName: 'rooster',
    description: 'Official RWA liquidity hub on Plume',
    href: 'https://www.rooster-protocol.xyz/?chain=98866',
  },
  {
    name: 'Ambient',
    appName: 'ambient',
    description: 'Zero-to-One Decentralized Trading Protocol',
    href: 'https://plume.ambient.finance/',
  },
  // {
  //   name: 'Camelot Exchange',
  //   appName: 'camelot',
  //   description: 'Custom-built liquidity infrastructure ',
  //   href: 'https://app.camelot.exchange/?chainId=98866',
  // },
];

const DexCard = ({
  name,
  description,
  href,
  appName,
}: {
  name: string;
  description: string;
  href: string;
  appName: string;
}) => {
  return (
    <HoverCardWithLink
      href={href}
      cardRootStyles={{
        w: 'full',
        p: [6, 6, 8],
        bg: 'bg',
        borderRadius: '16px',
      }}
      linkProps={{
        w: 'full',
      }}
    >
      <HStack gap={6} w="full">
        <Image src={getIconPathFromAppId(appName)} boxSize={10} borderRadius="md" />
        <VStack gap={1} alignItems="flex-start">
          <Heading fontSize="xl" fontWeight="700" lineHeight="28px" letterSpacing="-0.47px">
            {name}
          </Heading>
          <Text color="text.secondary" fontWeight="500">
            {description}
          </Text>
        </VStack>
      </HStack>
    </HoverCardWithLink>
  );
};

export const OtherDexInfo = () => {
  return (
    <VStack gap={5} w="full" alignItems="flex-start">
      <HStack justifyContent="space-between" w="full">
        <Heading fontSize="2xl" fontWeight="700" lineHeight="32px" letterSpacing="-0.47px">
          Other DEXs
        </Heading>
        <RoundedButton
          variant="outline"
          onClick={() => {
            window.open('/apps?type=DEX', '_self');
          }}
        >
          See All
        </RoundedButton>
      </HStack>
      <VStack gap={5} w="full" alignItems="flex-start">
        {dexs.map((dex) => (
          <DexCard key={dex.name} {...dex} />
        ))}
      </VStack>
    </VStack>
  );
};
